<template>
  <div id="HomeWrap" class="flex">
    <!-- 已登录状态 -->
    <div v-if="LoginUserInfo && LoginUserInfo.userId" class="LoginButton flex">
     <!-- <div @click="Exit" class="Exit"><img src="../assets/Home/exit.png"></div>-->
      <router-link tag="div" :to="{name:'PersonCenter'}" class="Exit"><img src="../assets/Home/exit.png"></router-link>
      <div>
        <div class="Hello flexa">Hello!<span>{{LoginUserInfo.username}}</span></div>
        <div class="PcName flexa"><img src="../assets/Home/pc.png"><span class="oneline">{{ currentSystem.name }}</span>
        </div>
        <div class="Change" @click="SubmitChange()" v-show="UserSystemList.length > 0"><img
                src="../assets/Home/change.png"></div>
      </div>
    </div>
    <!-- 未登录状态 -->
    <div v-else class="OpenLoginButton flex" @click="OpenLoginBox">
      <img src="../assets/Home/person.png">
    </div>
    <!-- 登录注册等弹出层 -->
    <div v-if="LoginPopWindow">
      <LoginPopWindow v-if="LoginPopWindowType === 'login'" @closeWindow="ClosePopWindow" @chooseSystem="SubmitChange"
                      @GetInitWorkData="GetInitWorkData">
<!--        <p @click="LoginPopWindowType = 'register'">立即注册</p>-->
        <p @click="LoginPopWindowType = 'forgetPasswd'">忘记密码?</p>
      </LoginPopWindow>
      <ForgetPasswdPopWindow v-else-if="LoginPopWindowType === 'forgetPasswd'" @closeWindow="ClosePopWindow"
                             @BackToLogin="BackToLogin"></ForgetPasswdPopWindow>
      <RegisterPopWindow v-else-if="LoginPopWindowType === 'register'" @closeWindow="ClosePopWindow"
                         @BackToLogin="BackToLogin"></RegisterPopWindow>
      <ChangePasswdPopWindow v-else-if="LoginPopWindowType === 'changePasswd'" @closeWindow="ClosePopWindow"></ChangePasswdPopWindow>
    </div>
    <!-- 选择系统 -->
    <div class="ChangePc" v-if="ChangeState">
      <div class="Boxbg" @click="CloseChangePcBox"></div>
      <div class="ChangeContent">
        <div class="ChangeTitle"><p>Hello</p>
          <p>请选择您的操作系统...</p></div>
        <div class="ChangeListWrap Scroll">
          <ul>
            <li class="flex" @click="SubmitChange(val)" v-for="(val, index) in UserSystemList"
                :key="'ChangeListWrapLi' + index">{{val.name}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 左侧工作区域 -->
    <div class="LeftContentWrap">
      <div v-if="currentSystem.code" style="height: calc(100% - 1.55rem);">
          <div class="ButtonsWrap flex"  @click="OpenSenchaBox('normal')">
   <!--           <i  @click="OpenSenchaBox('manager')"><img src="../assets/Home/b-1.png"></i>-->
<!--              <i  @click="OpenSenchaBox('normal')"><img src="../assets/Home/b-2.png"></i>-->
              <img src="../assets/Home/saas_icon.png"><p>运营平台</p>
          </div>
          <div class="JobWrap">
              <!-- 我的任务 -->
              <div class="WaittingWrap">
                  <div class="flexa JobTitle">
                      <p>我的任务</p>
                      <i class="MoreJob" @click="openSencha('task')"><img src="../assets/Home/more.png"></i>
                  </div>
                  <div class="WaittingItemWrap">
                      <ul>
                          <li class="flexa" v-for="(val, index) in ToDoWorks" @click="openSencha('task_type_' + val.处理)"
                              :key="'ToDoWorks' + index">
                              <div class="WaittingName flexa">
                                  <!--                  <img v-if="!val.图标" src="../assets/Buttonicon/icon11.png"/>-->
                                  <i v-if="!val.图标" class="fas fa-hashtag" />
                                  <img v-else-if="val.图标.indexOf('http') >= 0" :src="val.图标"/>
                                  <i v-else :class="val.图标"></i>
                                  <span>{{val.名称}}</span>
                              </div>
                              <div class="WaittingNum">
                                  {{val.数量}}
                              </div>
                          </li>
                      </ul>
                  </div>
              </div>
              <div class="QuickJobWrap">
                  <div class="flexa JobTitle">
                      <p>我的作业</p>
                      <i class="MoreJob" @click="openSencha('opration')"><img src="../assets/Home/more.png"></i>
                  </div>
                  <div class="JobListWrap clearfix">
                      <div class="IconWrap flexa" v-for="(val, index) in MyOprations" @click="openSencha('opration_'+ val.编码)"
                           :key="'myopration' + index">
                          <!--              <img v-if="!val.图标" src="../assets/Home/icon5.png"/>-->
                          <i v-if="!val.图标" class="fas fa-hashtag" />
                          <img v-else-if="val.图标.indexOf('http') >= 0" :src="val.图标"/>
                          <i v-else :class="val.图标"></i>
                          <p>{{val.名称}}</p></div>
                  </div>
              </div>
              <div class="QuickJobWrap">
                  <div class="flexa JobTitle">
                      <p>快捷工作</p>
                      <i class="MoreJob" @click="openSencha('shortcut')"><img src="../assets/Home/more.png"></i>
                  </div>
                  <div class="JobListWrap clearfix">
                      <div class="IconWrap flexa" v-for="(val, index) in ShortcutList" :key="'shortcut' + index"
                           @click="openSencha(val.编码)">
                          <!--              <img v-if="!val.图标" src="../assets/Home/icon1.png" />-->
                          <i v-if="!val.图标" class="fas fa-hashtag" />
                          <img v-else-if="val.图标.indexOf('http') >= 0" :src="val.图标" />
                          <i v-else :class="val.图标"></i>
                          <p>{{val.名称}}</p>
                      </div>
                  </div>
              </div>
              <div class="QuickJobWrap">
                  <div class="flexa JobTitle">
                      <p>我的工作</p>
                      <i class="MoreJob" @click="openSencha('main')"><img src="../assets/Home/more.png"></i>
                  </div>
                  <div class="JobListWrap clearfix">
                      <div class="IconWrap flexa" v-for="(val, index) in MyWorks" @click="openSencha(val.编码)"
                           :key="'mywork' + index">
                          <!--              <img v-if="!val.图标" src="../assets/Home/icon5.png"/>-->
                          <i v-if="!val.图标" class="fas fa-hashtag" />
                          <img v-else-if="val.图标.indexOf('http') >= 0" :src="val.图标"/>
                          <i v-else :class="val.图标"></i>
                          <p>{{val.名称}}</p></div>
                  </div>
              </div>
              <div class="QuickJobWrap">
                  <div class="flexa JobTitle">
                      <p>工作查询</p>
                      <i class="MoreJob" @click="openSencha('tasked')"><img src="../assets/Home/more.png"></i>
                  </div>
                  <div class="JobListWrap clearfix">
                      <div class="IconWrap flexa" v-for="(val, index) in MyQueries" @click="openSencha('tasked_' + val.编码)"
                           :key="'MyQueries' + index">
                          <!--              <img v-if="!val.图标" src="../assets/Home/icon5.png"/>-->
                          <i v-if="!val.图标" class="fas fa-hashtag" />
                          <img v-else-if="val.图标.indexOf('http') >= 0" :src="val.图标"/>
                          <i v-else :class="val.图标"></i>
                          <p>{{val.名称}}</p></div>
                  </div>
              </div>
            <div class="QuickJobWrap">
              <div class="flexa JobTitle">
                <p>仪表入口</p>
                <i class="MoreJob" @click="openSencha('dashfurniture')"><img src="../assets/Home/more.png"></i>
              </div>
            </div>
          </div>
      </div>
        <div v-else class="EmptyStateL">
            <div class="PL1">
                <img src="../assets/Pl1.png">
<!--                <p>工易SaaS平台是连接不同部门、不同层级、不同业务和不同平台的不同系统的数据交换和业务协同业务，创新的数据交换技术在无需统一主数据的前提下实现了组织间的业务协同及业务一体化的管理目标。</p>-->
            </div>
            <div class="PL3">
              <img src="../assets/Pl3.png">
              <!--                <p>工易SaaS平台是连接不同部门、不同层级、不同业务和不同平台的不同系统的数据交换和业务协同业务，创新的数据交换技术在无需统一主数据的前提下实现了组织间的业务协同及业务一体化的管理目标。</p>-->
            </div>
<!--            <router-link tag="div" :to="{name:'Store'}" class="PL3">-->
<!--                <img src="../assets/Pl3.png">-->
<!--            </router-link>-->
        </div>
    </div>
    <!-- 中间主要内容 -->
    <div class="CenterContentWrap">
      <header>
        <div class="HeadTitle flexbetween">
          <i><img src="../assets/Home/Logo.png"></i>
          <i><img src="../assets/Home/LogoTitle.png"></i>
        </div>
        <nav class="clearfix flexj">
            <div class="FindWrap"><i><img src="../assets/Home/find.png"></i></div>
           <div class="NavListWrap">
          <div v-for="(value,index) in NavData" :key="index" class="navlist" :class="{Active:$route.path === '/'+ value.link}"
               @click="ActiveChange(value.link)"><p>{{ value.name }}</p><i><img :src="value.img"></i></div>
           </div>
        </nav>
      </header>
      <div class="ContentWrap">
        <router-view @OpenLoginBox="OpenLoginBox"  @ShowChangePasswd="ShowChangePasswd"/>
      </div>
      <div class="MessageWrap hidden">
        <i><img src="../assets/Home/Message.png"></i>
      </div>
    </div>
    <!-- 右侧办公区域 -->
    <div class="RightContentWrap">
      <div v-if="currentSystem.code" style="height: calc(100% - 0.85rem);">
          <div class="JobWrap">
              <div class="DateWrap">
                  <div class="flexa DateTitle">
                      <p>我的日程</p>
                      <i class="MoreJob"><img src="../assets/Home/more.png"></i>
                  </div>
                  <div class="DateContentWrap">
                      <div class="Calendar clearfix">
                          <Calendar :Year="Year" :Month="Month" :num="scheduleNum"></Calendar>
                      </div>
                      <div class="Near flexa"><span>距最近日程</span></div>
                      <div class="NearName flexbetween">
                          <p>项目会议</p>
                          <p><span>03h25m</span></p>
                      </div>
                  </div>
              </div>
              <!-- 我的流程 -->
              <div class="ProjectList CommonStyle MyStep">
                  <!-- Title -->
                  <div class="JobTitle flexa">
                      <p>我的流程</p>
                      <i class="MoreJob" v-show="MyBusinessProcessShowOptions.isShow"
                         @click="menuButtonClick(MyBusinessProcessShowOptions)"><img src="../assets/Home/more.png"></i>
                  </div>
                  <div class="ContentWrap clearfix">
                      <div v-if="MyBusinessProcessShowOptions.isShow" class="MoreListWrap">
                          <div class="MoreTitle flexbetween">
                              <p>
                                  {{ MyBusinessProcessShowOptions.type }} 剩余 {{
                                  MyBusinessProcessShowOptions.number
                                  }} 项
                              </p>
                              <i @click="MyBusinessProcessShowOptions.isShow = false"><img src="../assets/Home/close.png"/></i>
                          </div>
                          <div class="ListContentWrap">
                              <ul>
                                  <li v-for="(val, index) in Portal_MyBusinessProcess_Data"
                                      :key="'Portal_MyBusinessProcess_Data' + index">
                                      <div class="Text">
                                          <p class="oneline">{{ val.名称 }}</p>
                                          <p>{{ val.作业名称 }} {{ val.用户 }}</p>
                                          <p class="twoline">
                                              {{ val.流程描述 }}
                                          </p>
                                      </div>
                                      <div class="TimeText">
                                          <p>预计完成时间</p>
                                          <p>{{ val.时间 && $utils.dateToString(val.时间) }}</p>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                      <div v-else class="CountWrap flex">
                          <div
                                  class="ButtonWrap"
                                  v-for="(val, index) in MyBusinessProcess_Group"
                                  :key="'MyBusinessProcess_Group' + index"
                                  @click="
              ProjectQuestionsBusinessClick(
                'Portal_MyBusinessProcess_Data',
                val
              )
            "
                          >
                              <span>{{ val.数量 }}</span>
                              <div class="flexa">
                                  <p>{{ val.名称 }}</p>
                                  <img v-if="!val.图标" :src="require('../assets/defaulticon/icon' + index + '.png')"/>
                                  <img v-else-if="val.图标.indexOf('http') >= 0" :src="val.图标"/>
                                  <i v-else :class="val.图标"></i>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- 我的项目 -->
              <div class="ProjectList CommonStyle MyProject">
                  <!-- Title -->
                  <div class="JobTitle flexa">
                      <p>我的项目</p>
                      <i class="MoreJob" v-show="MyProjectsShowOptions.isShow"
                         @click="menuButtonClick(MyProjectsShowOptions)"><img src="../assets/Home/more.png"></i>
                  </div>
                  <div class="ContentWrap clearfix">
                      <div v-if="MyProjectsShowOptions.isShow" class="MoreListWrap">
                          <div class="MoreTitle flexbetween">
                              <p>
                                  {{ MyProjectsShowOptions.type }} 剩余 {{
                                  MyProjectsShowOptions.number
                                  }} 项
                              </p>
                              <i @click="MyProjectsShowOptions.isShow = false"><img src="../assets/Home/close.png"/></i>
                          </div>
                          <div class="ListContentWrap">
                              <ul>
                                  <li v-for="(val, index) in Portal_MyProjects_Data"
                                      @click="openSencha(MyProjectsShowOptions.queryCode + '_' + val.编码)"
                                      :key="'Portal_MyProjects_Data' + index">
                                      <div class="Text">
                                          <p class="oneline">{{ val.名称 }}</p>
                                          <p></p>
                                          <p class="twoline">{{ val.项目说明 }}</p>
                                      </div>
                                      <div
                                              class="TimeText"
                                              v-if="MyProjectsShowOptions.type === '进行中'"
                                      >
                                          <p>开始日期</p>
                                          <p>{{ $utils.dateToString(val.开始日期, 1) }}</p>
                                      </div>
                                      <div
                                              class="TimeText"
                                              v-else-if="MyProjectsShowOptions.type === '已完成'"
                                      >
                                          <p>结束日期</p>
                                          <p>{{ $utils.dateToString(val.结束日期, 1) }}</p>
                                      </div>
                                      <div class="TimeText" v-else>
                                          <p>预计结束日期</p>
                                          <p>{{ $utils.dateToString(val.结束日期, 1) }}</p>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                      <div v-else class="CountWrap flex">
                          <div class="ButtonWrap" v-for="(val, index) in MyProjects_Group"
                               :key="'myProjectsGroup' + index"
                               @click="
              ProjectQuestionsBusinessClick('Portal_MyProjects_Data', val)
            ">
                              <span>{{ val.数量 }}</span>
                              <div class="flexa">
                                  <p>{{ val.名称 }}</p>
                                  <img v-if="!val.图标" :src="require('../assets/defaulticon/icon' + (index + 6) + '.png')"/>
                                  <img v-else-if="val.图标.indexOf('http') >= 0" :src="val.图标"/>
                                  <i v-else :class="val.图标"></i>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- 我的问题 -->
<!--              <div class="ProjectList CommonStyle MyQuestion">
                  &lt;!&ndash; Title &ndash;&gt;
                  <div class="JobTitle flexa">
                      <p>我的问题</p>
                      <i class="MoreJob" v-show="MyQuestionsShowOptions.isShow"
                         @click="menuButtonClick(MyQuestionsShowOptions)"><img src="../assets/Home/more.png"></i>
                  </div>
                  <div class="ContentWrap clearfix">
                      <div v-if="MyQuestionsShowOptions.isShow" class="MoreListWrap">
                          <div class="MoreTitle flexbetween">
                              <p>
                                  {{ MyQuestionsShowOptions.type }} 剩余 {{
                                  MyQuestionsShowOptions.number
                                  }} 项
                              </p>
                              <i @click="MyQuestionsShowOptions.isShow = false"><img src="../assets/Home/close.png"/></i>
                          </div>
                          <div class="ListContentWrap">
                              <ul>
                                  <li v-for="(val, index) in Portal_MyQuestions_Data"
                                      @click="openSencha(MyProjectsShowOptions.queryCode + '_' + val.编码)"
                                      :key="'Portal_MyQuestions_Data' + index">
                                      <div class="Text">
                                          <p class="oneline">{{ val.名称 }}</p>
                                          <p></p>
                                          <p class="twoline">
                                              {{ val.问题描述 }}
                                          </p>
                                      </div>
                                      <div class="TimeText">
                                          <p>日期</p>
                                          <p>{{ $utils.dateToString(val.日期, 1) }}</p>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                      <div v-else class="CountWrap flex">
                          <div class="ButtonWrap" v-for="(val, index) in MyQuestions_Group" :key="'myQuestionsGroup' + index"
                               @click="
              ProjectQuestionsBusinessClick('Portal_MyQuestions_Data', val)
            ">
                              <span>{{ val.数量 }}</span>
                              <div class="flexa">
                                  <p>{{ val.名称 }}</p>
                                  <img v-if="!val.图标" :src="require('../assets/defaulticon/icon' + (index + 3) + '.png')"/>
                                  <img v-else-if="val.图标.indexOf('http') >= 0" :src="val.图标"/>
                                  <i v-else :class="val.图标"></i>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>-->
              <!-- 我的数据 -->
              <div class="ProjectList MyData" v-if="MyDatas_Group.length > 0">
                  <!-- Title -->
                  <div class="JobTitle flexa">
                      <p>我的数据</p>
                      <i class="MoreJob"><img src="../assets/Home/more.png"/></i>
                  </div>
                  <!-- 列表 -->
                  <div class="DataList">
                      <ul>
                          <li class="List1 flexbetween">
                              <div class="Day">
                                  <p>全年工作当量</p>
                                  <p>单位 天</p>
                                  <p>{{ MyDatas_Group[0].全年工作当量 }}</p>
                              </div>
                              <div class="Day1">
                                  <p>本月当量</p>
                                  <p>{{ MyDatas_Group[0].当月工作当量 }}</p>
                                  <p>已完当量</p>
                                  <p>{{ MyDatas_Group[0].已完工作当量 }}</p>
                              </div>
                          </li>
                          <li class="List2">
                              <div class="flexa">
                                  <p>预算库</p>
                                  <p>{{ $utils.moneyFormat(MyDatas_Group[0].预算库总额) }}</p>
                              </div>
                              <div class="flexa">
                                  <p>资金库</p>
                                  <p>{{ $utils.moneyFormat(MyDatas_Group[0].资金库总额) }}</p>
                              </div>
                          </li>
                          <li class="List3">
                              <div class="flexbetween"><p>已结算金额</p>
                                  <p>项目工资总额</p></div>
                              <div class="flexbetween"><p>{{ $utils.moneyFormat(MyDatas_Group[0].已结算总额) }}</p>
                                  <p>{{ $utils.moneyFormat(MyDatas_Group[0].待结算总额) }}</p></div>
                          </li>
                          <li class="List4">
                              <div class="ChangeTitle"><p>资金变动</p></div>
                              <div class="flexbetween ChangeContent">
                                  <div class="Can"><img src="../assets/Home/Ca.png"></div>
                                  <div class="ChangeMoney">
                                      <div class="CC">
                                          <div class="AA clearfix">
                                              <p>{{
                                                  $utils.moneyFormat(
                                                  Math.abs(MyDatas_Group[0].资金变动1)
                                                  )
                                                  }}</p>
                                              <img :src="
                          MyDatas_Group[0].资金变动1 > 0
                            ? require('../assets/Home/add.png')
                            : require('../assets/Home/cut.png')
                        ">
                                          </div>
                                          <div class="BB"><p>{{ MyDatas_Group[0].资金摘要1 }}</p></div>
                                      </div>
                                      <div class="CC">
                                          <div class="AA clearfix">
                                              <p>
                                                  {{
                                                  $utils.moneyFormat(
                                                  Math.abs(MyDatas_Group[0].资金变动2)
                                                  )
                                                  }}
                                              </p>
                                              <img
                                                      :src="
                          MyDatas_Group[0].资金变动2 > 0
                            ? require('../assets/Home/add.png')
                            : require('../assets/Home/cut.png')
                        "
                                              />
                                          </div>
                                          <div class="BB">
                                              <p>{{ MyDatas_Group[0].资金摘要2 }}</p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
      </div>
        <div v-else class="EmptyStateR">
            <div class="PL2">
                <img src="../assets/Pl2.png">
          <!--      <p>工易PaaS平台是面向第三方开发平台，通过培训认证都可以成为工易PaaS平台的开发者，可以为客户定制开发服务，也可以上架开发者开发的标准产品到工易商城客户订阅使用。</p>-->
            </div>
            <router-link tag="div" :to="{name:'Builders'}" class="PL4">
                <img src="../assets/Pl4.png">
          <!--      <p>依托工易PaaS和SaaS平台,为第三方提供建模开发、产品管理、应用系统管理等功能，对第三方开发者和机构进行身份认证、签署电子合约, 为其提供持续技术支持和服务；实时监控应用系统的运行资源和状态，保障系统稳定运行。</p>-->
            </router-link>
        </div>
    </div>
  </div>
</template>

<script>
  import Calendar from '../components/Calendar';
  import LoginPopWindow from '../components/LoginPopWindow';
  import ForgetPasswdPopWindow from '../components/ForgetPasswdPopWindow';
  import ChangePasswdPopWindow from '../components/ChangePasswdPopWindow';
  import RegisterPopWindow from '../components/RegisterPopWindow';
  import { mapActions, mapGetters } from 'vuex';
  import axios from 'axios';
  // import qs from 'qs';

  export default {
    name: 'Index',
    inject: [
      'load'
    ],
    components: {
      Calendar,
      LoginPopWindow,
      ForgetPasswdPopWindow,
      ChangePasswdPopWindow,
      RegisterPopWindow
    },
    data() {
      return {
        /* {
         name: 'GE配置平台',
         icon: require('../../assets/Home/icon9.png'),
         info: '配置平台用于配置SaaS产品的专属应用系统，充分体现了工易SaaS平台由用户自己配置个性化应用的能力，自我适应企业个性化和变化。平台拥有组织管理器、作业岗位管理器、流程配置器和规则配置器。',
         type: 'manager'
       }, {
         name: 'GE运营平台',
         icon: require('../../assets/Home/icon10.png'),
         info: '运营平台由3个门户和七大板块构成，3个门户包括：WEB门户、APP门户和微信门户，七大板块包括工作、发现、云服务、即时通讯、消息服务、个人中心和工 易云(云服务入口)。',
         type: 'normal'
       }, */
        /* 分布式协同技术是解决产业链相关联业务异构系统之间作业协同的技术方案。 */
        NavData: [
          {
            name: '开发者',
            img: require('../assets/Home/nav6.png'),
            link: 'Builders'
          },
          // {
          //   name: '应用市场',
          //   img: require('../assets/Home/nav3.png'),
          //   link: 'Store'
          // },
          // {
          //   name: '解决方案',
          //   img: require('../assets/Home/nav7.png'),
          //   link: 'FangAn'
          // },
          {
            name: '智能业务链',
            img: require('../assets/Home/nav5.png'),
            link: 'LianWang'
          },
          {
            name: '智能体平台',
            img: require('../assets/Home/nav2.png'),
            link: 'Introduce'
          },
          {
            name: '首页',
            img: require('../assets/Home/nav1.png'),
            link: 'Home'
          }

          /*          {
            name: '云服务',
            img: require('../assets/Home/nav4.png'),
            link: 'Platform'
          }, */
        ],
        TabMoreState: false,
        LoginPopWindow: false,
        LoginPopWindowType: 'login', // login 登陆 forgetPasswd 忘记密码
        loginstate: true,
        findstate: false,
        ChangeState: false,
        Year: '',
        Month: '',
        scheduleNum: 16,
        loadingType: 0,
        loadingInfo: { id: '', password: '' },
        // currentSystem: { code: '', name: '' },
        ShortcutList: [],
        MyWorks: [],
        ToDoWorks: [],
        MyOprations: [],
        MySchedule: [],
        MyQueries: [],
        MyDatas_Group: [],
        MyProjects_Group: [],
        MyQuestions_Group: [],
        MyBusinessProcess_Group: [],
        Portal_MyProjects_Data: [],
        Portal_MyQuestions_Data: [],
        Portal_MyBusinessProcess_Data: [],
        MyProjectsShowOptions: {
          isShow: false,
          type: '',
          number: 0,
          code: '',
          queryCode: ''
        },
        MyQuestionsShowOptions: {
          isShow: false,
          type: '',
          number: 0,
          code: '',
          queryCode: ''
        },
        MyBusinessProcessShowOptions: {
          isShow: false,
          type: '',
          number: 0,
          code: '',
          queryCode: ''
        },
        noclickFlag: false,
        i: 60,
        Text: '发送验证码'
      };
    },
    computed: {
      ...mapGetters(['LoginUserInfo', 'UserSystemList', 'currentSystem'])
    },
    mounted () {
      let _this = this;
      console.log('vue-mounted');
      window.vueLoginOut = function () {
        _this.loginOut();
        _this.setCurrentSystem({ code: '', name: '' });
        setTimeout(() => {
          _this.$router.push({ path: '/' });
          _this.LoginPopWindow = true;
        }, 300);
      };
    },
    created() {
      if (this.LoginUserInfo && this.LoginUserInfo.userId) {
        if (!this.currentSystem.code) {
          if (this.UserSystemList.length > 1) {
            this.ChangeState = true;
          } else if (this.UserSystemList.length === 1) {
            this.setCurrentSystem({ name: this.UserSystemList[0].name, code: this.UserSystemList[0].id });
            axios({
              method: 'GET',
              headers: { 'content-type': 'application/x-www-form-urlencoded' },
              url: this.$loginUrl + 'api/login/seteom', // ?userid=50018,b86a7eb3-beff-4f49-9fb7-3abedc928661.杨福华0&eom=00326',
              params: {
                userid: this.LoginUserInfo.userId + '.' + this.LoginUserInfo.username,
                eom: this.UserSystemList[0].id
              }
            }).then((data) => {
              console.log(data);
              if (data.status === 200 && data.data.code === 0) {
                this.GetInitWorkData();
              } else {
                console.log(data.data.msg);
              }
            }, err => {
              console.log(err);
            });
          } else if (this.UserSystemList.length === 0) {
            this.ChangeState = false;
          }
        } else {
          this.GetInitWorkData();
        }
      }
    },

    methods: {
      OpenSenchaBox(type) {
        // debugger;
        if (type === 'model') {
          this.$store.dispatch('setplatformname', '开发平台');
        } else if (type === 'build') {
          this.$store.dispatch('setplatformname', '建模平台');
        } else if (type === 'xietong') {
          this.$store.dispatch('setplatformname', '协同平台');
        } else if (type === 'manager') {
          this.$store.dispatch('setplatformname', '配置平台');
        } else if (type === 'authentication' || type === 'normal' || type === 'test') {
          this.$store.dispatch('setplatformname', '运营平台');
        }
        if (this.LoginUserInfo.userId) {
          if (type === 'authentication' || type === 'normal') { // 认证 运营
            this.$store.dispatch('togglesenchabox', true);
            window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
          } else if (type === 'model' || type === 'manager' || type === 'test') { // 建模 配置
            axios({
              method: 'GET',
              headers: { 'content-type': 'application/x-www-form-urlencoded' },
              url: this.$loginUrl + 'api/login/getnewtoken', // ?userid=50018,b86a7eb3-beff-4f49-9fb7-3abedc928661.杨福华0&eom=00326',
              params: {
                userid: this.LoginUserInfo.userId, // + '.' + this.LoginUserInfo.username,
                identity: type
              }
            }).then((res) => {
              if (res.data.code === 0) {
                this.$store.dispatch('togglesenchabox', true);
                window.GEVAR.MainController.addInitPage({ user: [res.data.data.user], platform: type, data: res.data.data, code: this.currentSystem.code, name: this.currentSystem.name });
              }
            });
          }
        } else {
          this.$emit('OpenLoginBox');
        }
      },
      BackToLogin() {
        this.LoginPopWindowType = 'login';
        this.registerData = {
          phone: '',
          code: ''
        };
        this.forgetPasswdData = {
          phone: '',
          code: '',
          newPasswd: '',
          newPasswdAgain: ''
        };
      },
      ActiveChange(link) {
        if (link) {
          this.$router.push({
            path: link
          });
        }
      },
      menuButtonClick(data) {
        if (data.isShow) {
          // this.$router.push({ name: "Follow", params: { id: data.code } });
        }
      },
      CloseChangePcBox() {
        console.log(this.currentSystem);
        if (this.currentSystem.name !== '') {
          this.ChangeState = false;
        } else {
          this.$message.error('请选择系统!');
        }
      },
      ProjectQuestionsBusinessClick(servername, typeData) {
        if (typeData.数量 > 0) {
          this.getWorkData(servername, this.currentSystem.code, { datatype: typeData.名称 }).then(data => {
            if (data.isValid) {
              this[servername] = data.data;
              switch (servername) {
              case 'Portal_MyProjects_Data':
                this.MyProjectsShowOptions = {
                  isShow: true,
                  type: typeData.名称,
                  number: typeData.数量,
                  code: typeData.编码,
                  queryCode: typeData.查询
                };
                break;
              case 'Portal_MyQuestions_Data':
                this.MyQuestionsShowOptions = {
                  isShow: true,
                  type: typeData.名称,
                  number: typeData.数量,
                  code: typeData.编码,
                  queryCode: typeData.查询
                };
                break;
              case 'Portal_MyBusinessProcess_Data':
                this.MyBusinessProcessShowOptions = {
                  isShow: true,
                  type: typeData.名称,
                  number: typeData.数量,
                  code: typeData.编码,
                  queryCode: typeData.查询
                };
                break;
              default:
                break;
              }
            } else {
              console.log(data);
            }
          });
        }
      },
      getWorkData(servicename, eomid, param) {
        let params = {
          isEomLog: '1',
          eomid: eomid,
          appid: 'A01',
          appcode: 'A01',
          type: 'web',
          usercode: this.LoginUserInfo.userId,
          ...param
        };
        return new Promise((resolve, reject) => {
          axios({
            method: 'GET',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            // 公司系统的
            url: this.$baseUrl + servicename,
            params
          }).then((response) => {
            if (response.status === 200 && response.data.code === 0) {
              let { data } = response.data;
              if (typeof data === 'string') {
                data = JSON.parse(data);
              }
              resolve(data);
            } else {
              reject(response);
            }
          }, err => {
            reject(err);
          });
        });
      },
      openSencha(GoeasyMenuType) {
        this.togglesenchabox(true);
        window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], commandId: GoeasyMenuType, code: this.currentSystem.code, name: this.currentSystem.name });
      },
      GetInitWorkData() {
        let _this = this;
        this.getUserInfo();
        function * gen() {
          let keysArray = ['Portal_MySchedule',
                           'Portal_MyWorks',
                           'Portal_ToDoWorks',
                           'Portal_MyQueries',
                           'Portal_MyOprations',
                           'Portal_MyProjects_Group',
                           // 'Portal_MyQuestions_Group',
                           'Portal_MyBusinessProcess_Group',
                           'Portal_MyDatas_Group'];
          for (let val of keysArray) {
            yield _this.getWorkData(val, _this.currentSystem.code).then(data => {
              if (val === 'Portal_MyOprations') {
                console.log(data);
              }
              if (data.isValid) {
                _this[val.substring(7)] = data.data;
              } else {
                _this[val.substring(7)] = [];
              }
            });
          }
          yield _this.getWorkData('GetUserShortcutList', _this.currentSystem.code).then(data => {
            console.log('快捷工作列表:', data);
            if (data.data.length > 0) {
              _this.ShortcutList = data.data;
            } else {
              _this.ShortcutList = [];
            }
          });
        }

        this.load.show();
        let f = gen();
        do {
          f.next();
        } while (!f.next().done);
        this.load.hide();
      },
      SubmitChange(_system) {
        this.ChangeState = !this.ChangeState;
        if (_system) {
          this.setCurrentSystem({ name: _system.name, code: _system.id });

          axios({
            method: 'GET',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: this.$loginUrl + 'api/login/seteom', // ?userid=50018,b86a7eb3-beff-4f49-9fb7-3abedc928661.杨福华0&eom=00326',
            params: {
              userid: this.LoginUserInfo.userId, // + '.' + this.LoginUserInfo.username,
              eom: _system.id,
              getportal: 1
            }
          }).then((res) => {
            console.log(res);
            if (res.status === 200 && res.data.code === 0) {
              this.GetInitWorkData();
              localStorage.setItem('GoeasyServicelst', JSON.stringify(res.data.data.servicelst));
              sessionStorage.setItem('GoeasyServicelst', JSON.stringify(res.data.data.servicelst));
              sessionStorage.setItem('GoeasySecuritys', JSON.stringify(res.data.data.securitys));
              if (window.GEVAR && window.GEVAR.MainController && window.GEVAR.MainController.vueLoginIn) {
                window.GEVAR.MainController.vueLoginIn();
              };
              /*              if (res.data && res.data.servicelst && res.data.servicelst instanceof Array) {
                var manAPIs = [];
                res.data.servicelst.forEach((curitem) => {
                  if (curitem.API && curitem.API != '') {
                    manAPIs.push({ managerid: curitem.编码, api: curitem.API });
                  }
                });
                localStorage.setSessionValue('GE_ApiServers', JSON.stringify(manAPIs), '1');
              } */
              /* location.reload(); */
            } else {
              console.log(res.data.msg);
            }
          }, err => {
            console.log(err);
          });
        }
      },
      ClosePopWindow() {
        this.LoginPopWindow = false;
        this.LoginPopWindowType = 'login';
      },
      ShowChangePasswd() {
        this.LoginPopWindow = true;
        this.LoginPopWindowType = 'changePasswd';
      },
      Exit() {
        this.$confirm('是否确认退出当前账号?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loginOut();
          this.setCurrentSystem({ code: '', name: '' });
        }).catch(() => {
        });
      },
      OpenLoginBox() {
        this.LoginPopWindow = true;
      },
      ...mapActions(['userLogin', 'loginOut', 'setCurrentSystem', 'togglesenchabox', 'getUserInfo']),
      ...mapGetters(['UserInfo', 'currentSystem'])
    }
  };
</script>
<style lang="scss">
  @import '../../public/Value';

  #HomeWrap {
    width: 100%;
    height: 100%;
    background-color: #000000;
      .EmptyStateL{
          width: 1.15rem;
          height: calc(100% - 0.85rem);
          overflow-y: scroll;
          margin: 0.8rem  0 0 0.2rem;
          .PL3{
              cursor: pointer;
          }
          .PL1,.PL3{
              width: 1.05rem;
              position: relative;
              p{
                  font-size: 14px;
                  color: #fff;
                  position: absolute;
                  left: 0.06rem;
                  top: 70%;
                  width: 72%;
                  line-height: 21px;
              }
              img{
                  width: 100%;
              }
          }
          .PL3{
              margin-top: 0.08rem;
          }
          &::-webkit-scrollbar {
             display: none;
          }
      }
      @media screen and(max-width: 1920px){
          .EmptyStateL{
              width: 1.3rem;
              height: calc(100% - 0.85rem);
              overflow-y: scroll;
              margin: 0.8rem 0 0 0.29rem;
              .PL1,.PL3{
                  width: 1.05rem;
              }
          }
      }
    .EmptyStateR{
        width: 1.15rem;
        height: calc(100% - 0.85rem);
        overflow-y: scroll;
        margin: 0.8rem 0 0 0.65rem;
        .PL4{
            cursor: pointer;
        }
        .PL2,.PL4{
            width: 1.05rem;
            position: relative;
            img{
                width: 100%;
            }
            p{
                font-size: 14px;
                color: #fff;
                position: absolute;
                right: 0.06rem;
                top: 70%;
                width: 72%;
                line-height: 21px;
            }
        }
        .PL4{
            margin-top: 0.08rem;
            p{
                top: 40%;
            }
        }
        &::-webkit-scrollbar {
            display: none;
        }
    }
      @media screen and(max-width: 1920px){
          .EmptyStateR{
              width: 1.3rem;
              height: calc(100% - 0.85rem);
              overflow-y: scroll;
              margin: 0.8rem 0 0 0.55rem;
              .PL2,.PL4{
                  width: 1.05rem;
              }
          }
      }
      @media screen and(max-width: 1920px){
              .PL1,.PL2,.PL4{
                  p{
                      font-size: 12px !important;
                      line-height: 18px !important;
                  }
              }
      }
    .ChangePc {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.7);
      z-index: 5;
      .Boxbg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        cursor: pointer;
      }

      .ChangeContent {
        width: 2.7rem;
        height: calc(100% - 1rem);
        bottom: 0;
        left: 50%;
        margin-left: -1.35rem;
        position: absolute;
        z-index: 3;

        .ChangeListWrap {
          width: 100%;
          margin: 0.1rem auto 0;
          height: calc(100% - 0.4rem);

          ul {
            li {
              width: 100%;
              height: 0.25rem;
              font-size: $TextSize;
              background: linear-gradient(to right, #8b8bff, #4141b3);
              margin-bottom: 0.05rem;
              border-radius: 0.3rem;
              cursor: pointer;
              color: #fff;
            }
          }
        }

        .ChangeTitle {
          width: 100%;
          margin-top: 0.05rem;
          opacity: 0.9;

          p {
            font-size: $TextSize;
            color: #fff;
            text-indent: 0.05rem;
          }

          p:first-child {
            font-size: $TitleSize;
            margin-bottom: 0.02rem;
          }
        }
      }
    }

    .LoginBox {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.6);
      z-index: 3;

      .LoginContentWrap {
        width: 2.7rem;
        height: 2.2rem;
        border-radius: 0.02rem 0.1rem 0.1rem 0.1rem;
        background: linear-gradient(to bottom right, #6666cc, #4141b3);
        position: relative;

        .CloseBox {
          width: 0.15rem;
          height: 0.15rem;
          position: absolute;
          cursor: pointer;
          right: 0.05rem;
          top: 0.05rem;
          z-index: 4;

          img {
            width: 100%;
          }
        }

        .NeedKnown {
          position: absolute;
          width: 100%;
          bottom: 0.1rem;

          p {
            font-size: $SmallTextSize;
            color: #fff;
            text-align: center;

            span {
              cursor: pointer;
              font-weight: bold;
              margin: 0 0.02rem;
              color: #999900;
            }
          }
        }

        .InputWrap {
          width: 2.4rem;
          margin: 0.1rem auto 0;

          .InputContentWrap {
            width: 50%;
            margin-top: 0.1rem;

            .TabLog {
              width: 1rem;
              margin: 0 auto 0.1rem;

              div {
                width: 50%;
                height: 0.2rem;
                cursor: pointer;
                opacity: 0.6;

                span {
                  font-size: $TextSize;
                  color: #fff;
                }
              }

              .Active {
                border-bottom: 3px solid #b2e4fc;
                opacity: 1;
              }
            }

            .Find {
              width: 1rem;
              margin: 0.08rem auto 0.1rem;

              p {
                font-size: $AdditionTextSize;
                color: #fff;
                margin: 0 0.05rem;
                text-align: center;
                cursor: pointer;
              }
            }

            .SubmitButton {
              width: 1rem;
              height: 0.15rem;
              border-radius: 0.3rem;
              background-color: #fff;
              margin: 0.15rem auto 0;
              cursor: pointer;
              box-shadow: 5px 5px 15px #47478c;

              span {
                font-size: $TextSize;
                color: #4848b8;
              }
            }

            .AnotherLoginWrap {
              width: 100%;

              i {
                width: 0.4rem;
                height: 2px;
                background-color: #fff;
              }

              span {
                margin: 0 0.07rem;
                font-size: $SmallTextSize;
                color: #fff;
              }

              .IconWrap {
                width: 100%;
                margin-top: 0.05rem;

                i {
                  width: 0.2rem;
                  height: 0.2rem;
                  border-radius: 0.2rem;
                  cursor: pointer;
                  margin: 0 0.08rem;

                  img {
                    width: 100%;
                    height: 100%;
                    border-radius: 0.2rem;
                  }
                }
              }
            }

            .Input {
              width: 1rem;
              height: 0.18rem;
              border-bottom: 2px solid #fff;
              margin: 0 auto 0.1rem;

              input {
                width: 0.6rem;
                color: #fff;
                height: 100%;
                margin-left: 0.03rem;
                font-size: $AdditionTextSize;
                background-color: rgba(255, 255, 255, 0) !important;

                &:-webkit-autofill {
                  transition: background-color 5000s ease-in-out 0s;
                  -webkit-text-fill-color: #fff !important;
                }

                &:-webkit-autofill:focus {
                  -webkit-text-fill-color: #fff !important;
                }

                &::-moz-placeholder {
                  color: #fff;
                }

                &::-webkit-input-placeholder {
                  color: #fff;
                  opacity: 0.6;
                  font-size: $AdditionTextSize;
                }
              }

              .Send {
                width: 0.4rem;
                height: 0.12rem;
                background-color: #fff;
                border-radius: 0.1rem;
                cursor: pointer;
                box-shadow: 5px 5px 15px #47478c;

                span {
                  font-size: $SmallTextSize;
                  color: #4848b8;
                }
              }
            }
          }

          .CodeWrap {
            width: 50%;

            i {
              width: 1rem;
              margin: 0.15rem auto 0;

              img {
                width: 100%;
              }
            }

            p {
              margin-top: 0.07rem;
              font-size: $SmallTextSize;
              color: #fff;
              text-align: center;
            }
          }
        }

        .LoginTitle {
          width: 100%;
          margin-top: 0.05rem;

          p {
            font-size: $TextSize;
            color: #fff;
            text-indent: 0.05rem;
          }
        }
      }

      .Sin {
        .codes {
          background-color: transparent !important;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .FindPassword {
        position: relative;

        .Returns {
          width: 0.3rem;
          position: absolute;
          left: 0.1rem;
          bottom: 0.1rem;
          cursor: pointer;

          img {
            width: 100%;
          }
        }

        .InputContentWrap {
          margin-top: 0.1rem;
        }

        .CodeWrap {
          i {
            width: 1rem;
            margin: 0.4rem auto 0 !important;
          }
        }
      }
    }

    .OpenLoginButton {
      width: 0.35rem;
      height: 0.35rem;
      background: linear-gradient(to right, #6666cc, #4545b6);
      position: absolute;
      right: 0.05rem;
      top: 0.05rem;
      border-radius: 0.35rem 0.08rem 0.35rem 0.35rem;
      cursor: pointer;

      img {
        width: 0.25rem;
      }
    }

    .LoginButton {
      .Exit {
        cursor: pointer;
        position: absolute;
        right: 0.03rem;
        top: 0.03rem;

        img {
          width: 0.1rem;
        }
      }

      width: 1rem;
      height: 0.4rem;
      background: linear-gradient(to right, #6666cc, #4545b6);
      position: absolute;
      right: 0.05rem;
      top: 0.05rem;
      border-radius: 0.35rem 0.08rem 0.35rem 0.35rem;

      .Hello {
        width: 0.7rem;
        height: 0.15rem;
        border-bottom: 3px solid #00ffff;
        font-size: $SmallTextSize;
        color: #fff;

        span {
          font-size: $AdditionTextSize;
          color: #fff;
          text-indent: 0.02rem;
          font-weight: bold;
        }
      }

      .Change {
        cursor: pointer;
        position: absolute;
        right: 0.15rem;
        bottom: 0.07rem;

        img {
          width: 0.1rem;
        }
      }

      .PcName {
        width: 0.6rem;
        height: 0.17rem;

        img {
          height: 0.06rem;
        }

        span {
          font-size: $SmallTextSize;
          color: #fff;
          text-indent: 0.02rem;
        }
      }
    }

    @media screen and(max-width: 1400px) {
      .LoginButton {
        width: 1.2rem;

        .Hello {
          width: 0.9rem;
        }

        .PcName {
          width: 0.8rem;
        }
      }
    }

    .LeftContentWrap {
        .ButtonsWrap{
            width: 1.4rem;
            height: 0.5rem;
            border-radius: 0.1rem;
            cursor: pointer;
      /*      background-image: url('../assets/Home/buttonbg.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;*/
            background-color: #902d2d;
            position: absolute;
            top: 0.79rem;
            left: 0.085rem;
            img{
                width: 0.2rem;
                margin-right: 0.05rem;
            }
            p{
                font-size: 0.1rem;
                font-weight: bold;
                color: #fff;
            }
/*            i{
                width: 0.35rem;
                margin: 0 0.2rem;
                cursor: pointer;
                img{
                    width: 100%;
                }
            }*/
        }
      .JobWrap {
          width: 80%;
          height: 100%;
          overflow-y: scroll;
          margin: 1.5rem 0 0 0.08rem;

        &::-webkit-scrollbar {
          width: 2px;
          height: 2px;
        }

        &::-webkit-scrollbar-track {
          width: 2px;
          background: #1f1f1f;
        }

        &::-webkit-scrollbar-thumb {
          width: 2px;
          background: #616161;
        }

        .WaittingWrap {
          width: 100%;
          margin-bottom: 0.25rem;

          .JobTitle {
            width: 100%;
            position: relative;
            height: 0.1rem;

            p {
              font-size: $TextSize;
              color: #fff;
            }

            .MoreJob {
              width: 0.08rem;
              position: absolute;
              right: 0.08rem;
              cursor: pointer;

              img {
                width: 100%;
              }
            }
          }

          .WaittingItemWrap {
            width: 100%;
            margin-top: 0.1rem;

            ul {
              width: 100%;

              li {
                width: 95%;
                height: 0.32rem;
                background: linear-gradient(to right, #000000, #1f1f1f);
                margin-bottom: 0.07rem;
                border-radius: 0.1rem;
                border: 2px solid #1f1f1f;
                position: relative;

                .WaittingNum {
                  font-size: $NumTitleSize;
                  font-weight: bold;
                  position: absolute;
                  right: 0.1rem;
                  -webkit-text-stroke: 1px #fff;
                  color: transparent;
                }

                .WaittingName {
                  margin-left: 0.1rem;

                  img {
                    width: 0.1rem;
                    margin-right: 0.03rem;
                  }

                  i {
                    font-size: 0.1rem;
                    margin-right: 0.03rem;
                    color: #e5e5e5;
                  }

                  span {
                    font-size: $TextSize;
                    color: #fff;
                  }
                }
              }
            }
          }
        }

        .QuickJobWrap {
          width: 100%;
          margin-bottom: 0.25rem;

          .JobListWrap {
            width: 100%;
            margin-top: 0.1rem;

            .IconWrap {
              width: 0.3rem;
              height: 0.3rem;
              /*              border-radius: 0.05rem;
                            box-shadow: 0 0 30px #2b2b2b inset;
                            border: 2px solid #333333;*/
              float: left;
              margin-right: 0.05rem;
              margin-bottom: 0.05rem;
              cursor: pointer;
              position: relative;
              background-image: url("../assets/Buttonicon/bg.png");
              background-size: 100% 100%;
              background-repeat: no-repeat;

              img {
                height: 0.12rem;
                margin: 0 auto;
                transition: all 0.3s;
              }

              p {
                text-align: center;
                font-size: $SmallTextSize;
                color: #fff;
                opacity: 0;
                position: absolute;
                width: 100%;
                transition: all 0.8s;
              }

              i {
                color: #e5e5e5;
                font-size: 0.12rem;
                margin: 0 auto;
                transition: all 0.3s;
              }
            }

            .IconWrap:hover {
              img {
                opacity: 0.15;
              }

              p {
                opacity: 1;
              }

              i {
                opacity: 0.15;
              }
            }

            .IconWrap:last-child {
              margin-right: 0;
            }
          }

          .JobTitle {
            width: 100%;
            position: relative;
            height: 0.1rem;

            p {
              font-size: $TextSize;
              color: #fff;
            }

            .MoreJob {
              width: 0.08rem;
              position: absolute;
              right: 0.08rem;
              cursor: pointer;

              img {
                width: 100%;
              }
            }
          }
        }
      }
    }

    .LeftContentWrap, .RightContentWrap {
      width: 25%;
      height: 100%;
    }

    .CenterContentWrap {
      width: 50%;
      height: 100%;

      .MessageWrap {
        position: absolute;
        right: 1.7rem;
        bottom: 0.1rem;
        z-index: 5;
        cursor: pointer;

        i {
          width: 0.3rem;

          img {
            width: 100%;
          }
        }
      }

      .ContentWrap {
        width: 100%;
        height: calc(100% - 0.85rem);
        margin-top: 0.15rem;

        & > div {
          height: 100%;
          overflow-y: scroll;

          &::-webkit-scrollbar {
            display: none;
          }

          scrollbar-color: transparent transparent;
          scrollbar-track-color: transparent;
          -ms-scrollbar-track-color: transparent;
        }
      }

      header {
        nav {
          width: 100%;
          margin-top: 0.2rem;
          position: relative;
          height: 0.2rem;
          .NavListWrap{
              position: absolute;
              right: 0;
          }
            .FindWrap{
                position: absolute;
                left: 0.05rem;
                cursor: pointer;
                i{
                    width: 0.09rem;
                    img{
                        width: 100%;
                    }
                }
            }
          .navlist {
            height: 0.2rem;
            font-size: $TextSize;
            color: #fff;
            float: right;
            padding: 0 0.05rem;
            margin-left: 0.1rem;
            box-sizing: border-box;

            p {
              width: 100%;
              text-align: center;
              padding-bottom: 0.02rem;
              margin-bottom: 0.02rem;
              opacity: 0.9;
            }

            i {
              height: 0.1rem;
              opacity: 0;

              img {
                height: 100%;
                margin: 0 auto;
              }
            }
          }

          .navlist:hover {
            cursor: pointer;

            p {
              border-bottom: 2px solid #00ffff;
              opacity: 1;
            }

            i {
              opacity: 1;
            }
          }

          .Active {
            p {
              opacity: 1;
              border-bottom: 2px solid #00ffff;
            }

            i {
              opacity: 0;
            }
          }
        }

        .HeadTitle {
          width: 98%;
          padding-top: 0.1rem;
          margin: 0 auto;

          i {
            height: 0.15rem;

            img {
              height: 100%;
            }
          }
        }
      }

    }

    .RightContentWrap {
      .JobWrap {
        .MyData {
          .DataList {
            width: 95%;

            ul {
              width: 100%;

              li {
                width: 100%;
                height: 0.56rem;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                margin-bottom: 0.1rem;
                position: relative;
              }

              .List1 {
                background-image: url("../assets/BG/bg1.jpg");

                .Day {
                  margin: 0.05rem 0 0 0.07rem;

                  p {
                    font-size: $TextSize;
                    color: #fff;
                  }

                  p:nth-child(2) {
                    font-size: $AdditionTextSize;
                    opacity: 0.6;
                    margin-bottom: 0.11rem;
                    margin-top: 0.05rem;
                  }

                  p:last-child {
                    font-size: $TitleSize;
                  }
                }

                .Day1 {
                  margin: 0.05rem 0.07rem 0 0;

                  p {
                    font-size: $AdditionTextSize;
                    color: #fff;
                  }

                  p:nth-child(odd) {
                    opacity: 0.6;
                    margin-bottom: 0.01rem;
                  }

                  p:nth-child(even) {
                    font-size: $TitleSize;
                  }

                  p:nth-child(3) {
                    margin-top: 0.02rem;
                  }
                }
              }

              .List2 {
                background-image: url("../assets/BG/bg2.jpg");

                div {
                  width: 1rem;
                  margin-left: 0.35rem;
                  position: relative;

                  p {
                    font-size: $AdditionTextSize;
                    color: #fff;
                  }

                  p:last-child {
                    font-size: $TitleSize;
                    position: absolute;
                    right: 0;
                  }
                }

                div:first-child {
                  padding-top: 0.085rem;
                }

                div:last-child {
                  position: absolute;
                  bottom: 0.085rem;
                  left: 0.35rem;
                  margin-left: 0;
                }
              }

              .List3 {
                background-image: url("../assets/BG/bg3.jpg");

                div {
                  width: 90%;
                  margin: 0 auto;

                  p {
                    font-size: $TextSize;
                    color: #fff;
                  }
                }

                div:first-child {
                  padding-top: 0.06rem;
                  opacity: 0.8;
                }

                div:last-child {
                  position: absolute;
                  bottom: 0.06rem;
                  left: 5%;

                  p {
                    font-size: $TitleSize;
                    font-weight: bold;
                  }
                }
              }

              .List4 {
                background-image: url("../assets/BG/bg4.jpg");
                height: 0.7rem;

                .ChangeTitle {
                  width: 90%;
                  margin: 0 auto;
                  padding-top: 0.06rem;

                  p {
                    font-size: $TextSize;
                    text-align: left;
                    color: #fff;
                    opacity: 0.8;
                  }
                }

                .ChangeContent {
                  width: 90%;
                  margin: 0 auto;

                  .Can {
                    img {
                      width: 0.4rem;
                      margin-top: 0.1rem;
                    }
                  }

                  .ChangeMoney {
                    .CC {
                      margin-bottom: 0.05rem;
                    }

                    .CC:last-child {
                      p {
                        opacity: 0.6;
                      }
                    }

                    .BB {
                      p {
                        font-size: $SmallTextSize;
                        color: #fff;
                        text-align: right;
                        margin-top: 0.02rem;
                      }
                    }

                    .AA {
                      img {
                        width: 0.1rem;
                        margin-right: 0.01rem;
                        margin-top: 0.02rem;
                        float: right;
                      }

                      p {
                        font-size: $TitleSize;
                        color: #fff;
                        font-weight: bold;
                        float: right;
                        margin-top: 0.04rem;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .JobTitle {
          width: 100%;
          margin-bottom: 0.1rem;
          position: relative;

          p {
            font-size: $TextSize;
            color: #fff;
          }

          .MoreJob {
            width: 0.08rem;
            position: absolute;
            right: 0.08rem;
            cursor: pointer;

            img {
              width: 100%;
            }
          }
        }

        .DateWrap {
          .DateContentWrap {
            width: 94%;
            margin-top: 0.1rem;
            border: 2px solid #313131;
            background: linear-gradient(to right, #000000, #1f1f1f);
            border-radius: 0.1rem;

            .NearName {
              width: 1.25rem;
              height: 0.15rem;
              margin: 0 auto;
              padding-bottom: 0.05rem;

              p {
                font-size: $TextSize;
                color: #fff;
                text-indent: 0.01rem;

                span {
                  font-size: $TitleSize;
                }
              }
            }

            .Near {
              width: 1.255rem;
              height: 0.15rem;
              margin: 0.05rem auto 0;
              border-top: 2px solid #00ffff;

              span {
                font-size: $SmallTextSize;
                color: #fff;
                opacity: 0.4;
                text-indent: 0.01rem;
              }
            }

            .Calendar {
              width: 100%;
            }
          }

          .DateTitle {
            width: 100%;
            position: relative;
            height: 0.1rem;

            p {
              font-size: $TextSize;
              color: #fff;
            }

            .MoreJob {
              width: 0.08rem;
              position: absolute;
              right: 0.08rem;
              cursor: pointer;

              img {
                width: 100%;
              }
            }
          }
        }

        .ProjectList {
          width: 100%;
          margin: 0.25rem auto 0;
        }

        .CommonStyle {
          width: 100%;

          .MoreListWrap {
            width: 95%;

            .MoreTitle {
              width: 100%;
              margin-bottom: 0.03rem;

              p {
                font-size: $AdditionTextSize;
                opacity: 0.6;
                color: #fff;
                margin-left: 0.03rem;
              }

              i {
                width: 0.08rem;
                height: 0.08rem;
                opacity: 0.6;
                cursor: pointer;
                margin-right: 0.005rem;

                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            .ListContentWrap {
              width: 100%;

              ul {
                width: 100%;

                li {
                  width: 100%;
                  background: linear-gradient(to right, #000000, #1f1f1f);
                  border-radius: 0.1rem;
                  margin-bottom: 0.03rem;
                  border: 2px solid #1f1f1f;
                  position: relative;

                  .TimeText {
                    position: absolute;
                    right: 0.07rem;
                    top: 0.05rem;

                    p {
                      font-size: $AdditionTextSize;
                      opacity: 0.4;
                      color: #fff;
                      margin-bottom: 0.02rem;
                    }
                  }

                  .Text {
                    width: 0.8rem;
                    padding: 0.05rem 0;
                    margin-left: 0.07rem;

                    p {
                      color: #fff;
                    }

                    p:first-child {
                      font-size: $TextSize;
                      font-weight: bold;
                    }

                    p:nth-child(2) {
                      font-size: $AdditionTextSize;
                      margin: 0.01rem 0 0.05rem;
                      opacity: 0.4;
                    }

                    p:last-child {
                      font-size: $TextSize;
                      opacity: 0.8;
                    }
                  }
                }
              }
            }
          }

          .CountWrap {
            width: 95%;
            height: 0.5rem;
            background: linear-gradient(to Right Bottom, #1d1d1d, #000000);
            border-radius: 0.1rem;
            border: 2px solid #1d1d1d;

            .ButtonWrap {
              width: 0.45rem;
              height: 0.4rem;
              position: relative;
              border-right: 2px solid #fff;

              span {
                position: absolute;
                right: 0.05rem;
                top: 0.02rem;
                font-size: $NumTitleSize;
                font-weight: bold;
                color: #fff;
                line-height: 1
              }

              div {
                width: 90%;
                position: absolute;
                bottom: 0.02rem;
                left: 0.02rem;

                p {
                  font-size: $AdditionTextSize;
                  color: #fff;
                  opacity: 0.8;
                  margin-top: 0.02rem;
                }

                img {
                  height: 0.12rem;
                  position: absolute;
                  right: 0;
                }

                i {
                  font-size: 0.12rem;
                  position: absolute;
                  right: 0;
                  color: #e5e5e5;
                }
              }
            }

            .ButtonWrap:nth-child(3) {
              border-right: none;
            }
          }
        }

        width: 83%;
        height: 100%;
        overflow-y: scroll;
        margin: 0.8rem 0 0 0.25rem;

        &::-webkit-scrollbar {
          width: 2px;
          height: 2px;
        }

        &::-webkit-scrollbar-track {
          width: 2px;
          background: #1f1f1f;
        }

        &::-webkit-scrollbar-thumb {
          width: 2px;
          background: #616161;
        }
      }
    }
  }

  // 1366适配阴影
  /*@media screen and (max-width: 1400px) {
      .LeftShadow{
          left: -0.1rem !important;
      }
      .RightShadow{
          right: -0.1rem !important;
      }
  }*/
</style>
